import React from 'react';
import { Shield } from 'lucide-react';
import { Badge, Button, Avatar } from '../ui';

interface GuardianActivityProps {
  dependentActivity: Array<{
    id: string;
    name: string;
    relation: string;
    org: string;
    type: string;
    detail: string;
    priority: string;
  }>;
}

export const GuardianActivity: React.FC<GuardianActivityProps> = ({ dependentActivity }) => {
  return (
    <section className="bg-amber-50/50 border-2 border-black dark:border-white border-amber-100 dark:bg-amber-900/10 dark:border-amber-900/30 rounded-none p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 rounded-none">
            <Shield size={20} />
          </div>
          <div>
            <h3 className="font-bold text-gray-900 dark:text-white">Guardian Activity</h3>
            <p className="text-xs text-amber-800 dark:text-amber-500">Aggregated alerts for your linked dependents.</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {dependentActivity.map(item => (
          <div key={item.id} className="bg-white p-4 rounded-none border-2 border-black dark:border-white border-amber-200 dark:border-amber-900/50 shadow-[4px_4px_0px_#000000] dark:shadow-[4px_4px_0px_#FFFFFF] flex items-center justify-between group hover:border-amber-400 dark:hover:border-amber-700 transition-colors dark:bg-slate-900">
            <div className="flex items-center gap-4">
              <Avatar userId="child-1" initials={item.name?.[0] || '?'} size="sm" className="bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400" />
              <div>
                <div className="flex items-center gap-2">
                  <p className="text-xs font-bold text-gray-900 dark:text-white">{item.name}</p>
                  <Badge variant="gray" className="text-[8px] py-0 px-1 font-mono uppercase bg-white dark:bg-slate-800">{item.relation}</Badge>
                </div>
                <p className="text-[10px] text-gray-500 dark:text-gray-400">{item.org}</p>
                <p className="text-xs font-medium text-amber-900 dark:text-amber-400 mt-1">{item.detail}</p>
              </div>
            </div>
            <Button size="sm" variant="secondary" className="bg-amber-100 text-amber-900 border-none hover:bg-amber-200 dark:bg-amber-900/30 dark:text-amber-400 dark:hover:bg-amber-900/50">
              Manage
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};
